
<div mat-dialog-content class="w-full bg-white !p-0 !m-0">
  <div class="card-wrapper type-modal" [formGroup]="organizationForm">
    <div class="card">
      <h3 class="green decoration mb-4">Detalles del pago</h3>

      <div class="form-wrapper mb-3" [class.control-invalid]="organizationForm.get('customer_id').dirty && organizationForm.get('customer_id').invalid">
        <span>Nombre del Cliente:</span>
        <select formControlName="customer_id" [attr.disabled]="true">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let organization of organizations" [value]="organization.id">{{ organization.name }}</option>
        </select>
        <p *ngIf="organizationForm.get('customer_id').dirty && organizationForm.get('customer_id').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="organizationForm.get('customer_id').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="organizationForm.get('due_payment_id').dirty && organizationForm.get('due_payment_id').invalid">
        <span>Deudas:</span>
        <select formControlName="due_payment_id" [attr.disabled]="true">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let duePayment of duePayments" [value]="duePayment.id">{{ duePayment.name_organization }}</option>
        </select>
        <p *ngIf="organizationForm.get('due_payment_id').dirty && organizationForm.get('due_payment_id').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="organizationForm.get('due_payment_id').errors.required">Este campo es necesario</label>
        </p>
      </div>
    </div>
    <div class="card">
      <h3 class="green" style="margin-bottom: 1.6rem;">&nbsp;</h3>
      <div class="form-wrapper mb-3" [class.control-invalid]="organizationForm.get('amount').dirty && organizationForm.get('amount').invalid">
        <span>Monto:</span>
        <input type="text" formControlName="amount" [attr.disabled]="true">
        <p *ngIf="organizationForm.get('amount').dirty && organizationForm.get('amount').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="organizationForm.get('amount').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="organizationForm.get('detail').dirty && organizationForm.get('detail').invalid">
        <span>Detalle:</span>
        <input type="text" formControlName="detail" [attr.disabled]="true">
        <p *ngIf="organizationForm.get('detail').dirty && organizationForm.get('detail').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="organizationForm.get('detail').errors.required">Este campo es necesario</label>
        </p>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex justify-end actions_modal">
        <!-- <button cdkFocusInitial mat-button class="!hidden">Autofocus disabled</button> -->
        <!-- <button mat-button type="button" (click)="dismiss()" class="btn btn-gray big">Cancelar</button> -->
        <button mat-button type="button" (click)="dismiss()" class="btn btn-primary big">Aceptar</button>
  </div>
</div>
